/* eslint-disable arrow-body-style */
import React from 'react';

import { useHistory, useLocation } from 'react-router-dom';
import ReactNetflixPlayer from 'react-netflix-player';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import styled from 'styled-components/macro';

const Back = styled.p`
  position: absolute;
  top: 15px;
  left: 15px;
  color: white;
  z-index: 89999;
  display: flex;
`;

const BackText = styled.p`
  margin-left: 8px;
  cursor: pointer;
`;

const Watch = () => {
  const location = useLocation();
  const { title, video, genre } = location.state;

  console.log(video);

  const history = useHistory();

  function handleClick() {
    history.push('/');
    document.body.setAttribute('style', '');
  }

  return (
    <div>
      <Back onClick={handleClick}>
        <FontAwesomeIcon
          icon={faArrowLeft}
          size="3x"
          style={{ color: 'white', cursor: 'pointer' }}
        />
        <BackText>Back</BackText>
      </Back>
      <ReactNetflixPlayer
        autoPlay
        title={title}
        subTitle={title}
        extraInfoMedia={genre}
        playerLanguage="en"
        titleMedia={title}
        src={video}
      />
    </div>
  );
};

export default Watch;
